module.exports = __webpack_public_path__ + "static/media/searchIcon.547cd5ed.svg";